/**
 * @fileoverview GET handler for the "/apps/aggregate_push_credential_info" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAggregatePushCredentialInfo } from "./constants";
import type { AppsAggregatePushCredentialInfoResult } from "./types";

export const getAppsAggregatePushCredentialInfo = reactQueryFetcherAdapter(
  appsAggregatePushCredentialInfo,
  (signal: AbortSignal): Promise<AppsAggregatePushCredentialInfoResult> => {
    return fetch("/apps/aggregate_push_credential_info", "GET", {}, { signal });
  }
);
